<template>
  <b-form-group :label="label">
    <b-input-group>
      <b-input-group-prepend
        v-if="icon"
        is-text
        :class="{ 'cursor-pointer': linkToOpen }"
        :title="linkToOpen && 'Abrir arquivo'"
        @click="openFile"
      >
        <b-icon :icon="icon" />
      </b-input-group-prepend>

      <b-form-file
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        :required="required"
        :accept="accept"
        browse-text="Localizar"
        @input="$emit('input', $event)"
      />
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  name: "FormInput",
  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    accept: {
      type: String,
      require: true,
    },
    linkToOpen: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    openFile() {
      if (this.linkToOpen) {
        window.open(this.linkToOpen, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
